import type { ExpandedState } from '@tanstack/react-table';

/** A table's expanded rows by id, as the DataTable reports them. `true` (all) reads as none. */
export function expandedRowIds(next: ExpandedState): Record<string, boolean> {
  return next === true ? {} : next;
}

/**
 * The rows whose state just flipped, opened or closed. Ember's row reports every toggle, so a close
 * counts the same as an open.
 *
 * Callers diff against a ref rather than rendered state: two toggles dispatched before React
 * commits would otherwise both compare to the same stale map and report the first row twice.
 */
export function toggledRowIds(previous: Record<string, boolean>, next: Record<string, boolean>): string[] {
  const ids = new Set([...Object.keys(previous), ...Object.keys(next)]);
  return [...ids].filter((id) => (previous[id] === true) !== (next[id] === true));
}
